/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_Entity_NoneInputs */

const cs_settings_office_legal_entity_none = /** @type {(inputs: Settings_Office_Legal_Entity_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez zastřešující firmy`)
};

const en_settings_office_legal_entity_none = /** @type {(inputs: Settings_Office_Legal_Entity_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No umbrella company`)
};

/**
* | output |
* | --- |
* | "No umbrella company" |
*
* @param {Settings_Office_Legal_Entity_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_entity_none = /** @type {((inputs?: Settings_Office_Legal_Entity_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_Entity_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_entity_none(inputs)
	return cs_settings_office_legal_entity_none(inputs)
});